import React, { useState, useRef } from 'react';
import './css/MediaSection.css';
import image1 from './image/media-art/1.webp';
import image2 from './image/media-art/2.webp';
import image3 from './image/media-art/3.webp';
import image4 from './image/media-art/4.webp';
import image5 from './image/media-art/5.webp';
import image6 from './image/media-art/6.webp';
import image7 from './image/media-art/7.webp';
import image8 from './image/media-art/8.webp';
import image9 from './image/media-art/9.webp';
import image10 from './image/media-art/10.webp';
import image11 from './image/media-art/11.webp';
import image12 from './image/media-art/12.webp';
import image13 from './image/media-art/13.webp';
import image14 from './image/media-art/14.webp';
import image15 from './image/media-art/15.webp';
import image16 from './image/media-art/16.webp';
import image17 from './image/media-art/17.webp';
import image18 from './image/media-art/18.webp';

const galleryItems = [
  { src: image1, alt: "Media 1"},
  { src: image2, alt: "Media 2"},
  { src: image3, alt: "Media 3"},
  { src: image4, alt: "Media 4"},
  { src: image5, alt: "Media 5"},
  { src: image6, alt: "Media 6", text: "Création de I°mania, pièce mixte pour deux guitares électriques et bande avec Guillaume Bleton" },
  { src: image7, alt: "Media 7"},
  { src: image8, alt: "Media 8", text: "Restitution de la Capsule Sonore 9 à Lyon" },
  { src: image9, alt: "Media 9", text: "Interview pour la création sonore Cairn" },
  { src: image10, alt: "Media 10", text: "Création sonore pour un spectacle, avec des personnes exilées, dans un tiers-lieu rennais" },
  { src: image11, alt: "Media 11", text: "Création sonore pour un spectacle, avec des personnes exilées, dans un tiers-lieu rennais" },
  { src: image12, alt: "Media 12", text: "Mix de corps sonores pour les ateliers" },
  { src: image13, alt: "Media 13", text: "Ateliers de création d'instruments avec des matériaux recyclés à Mulhouse" },
  { src: image14, alt: "Media 14", text: "Ateliers de création sonore avec les résidents seniors de l'Union Belge à Courbevoie" },
  { src: image15, alt: "Media 15", text: "Mix de corps sonores pour les ateliers" },
  { src: image16, alt: "Media 16", text: "Création sonore avec des participants de Villeneuve la garenne à la Seine Musicale à Boulogne et au Pôle Social Départemental de Villeneuve" },
  { src: image17, alt: "Media 17", text: "Ateliers de création sonore avec les élèves du lycée Paul Painlevé à Courbevoie" },
  { src: image18, alt: "Media 18", text: "Petit studio de création à Marseille" },
];

const MediaSection = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedText, setSelectedText] = useState('');
  const mediaRef = useRef(null);

  const handleImageClick = (item) => {
    setSelectedImage(item.src);
    setSelectedText(item.text);
  };

  const closePopup = () => {
    setSelectedImage(null);
    setSelectedText('');
  };

  return (
    <div className="scroll-section" id="media" ref={mediaRef}>
      <h6 className="section-title" data-aos="fade-up">Gallerie</h6>
      <div className="media-gallery">
        {galleryItems.map((item, idx) => (
          <div
            className="media-item"
            data-aos="fade-up"
            key={idx}
            onClick={() => handleImageClick(item)}
          >
            <img src={item.src} alt={item.alt} />
          </div>
        ))}
      </div>
      {selectedImage && (
        <div className="popup media-popup" onClick={closePopup}>
          <div className="popup-content">
            <img src={selectedImage} alt="Selected" />
            <div className="popup-text">
              <h4>{selectedText}</h4>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MediaSection;